<template>
  <div class="tw:bg-gray-100 tw:flex tw:w-full tw:py-12">
    <ContainerLayout>
      <div class="tw:hidden tw:md:flex tw:w-1/3">
        <img
          src="@/assets/img/studio-plus/studio-plus-compare-banner.svg"
          :alt="$t('plus_product_page_benefit_header')"
          width="314"
          class="tw:w-[314px] tw:ml-auto"
        />
      </div>
      <div class="tw:mx-auto">
        <h3 class="tw:font-bold tw:text-2xl tw:text-center tw:md:text-left">
          {{ $t('plus_product_page_benefit_header') }}
        </h3>
        <img
          src="@/assets/img/studio-plus/studio-plus-compare-banner.svg"
          :alt="$t('plus_product_page_benefit_header')"
          width="314"
          class="tw:md:hidden tw:mx-auto tw:my-9"
        />
        <ul class="tw:my-8">
          <li v-for="(item, i) in list" :key="i" class="tw:flex tw:items-center tw:my-4 tw:text-xl tw:leading-[30px]">
            <CheckMark class="tw:mr-4 tw:h-[20px] tw:w-[20px] tw:p-[4px] tw:rounded-full" />
            {{ $t(item) }}
          </li>
        </ul>
        <div class="tw:flex tw:gap-4 tw:md:flex-row tw:flex-col tw:items-center">
          <MainButton @click="upgradeSub">{{
            isAdmin ? $t('plus_product_page_cta') : $t('rc_admin_log_in_cta')
          }}</MainButton>
          <UiTooltip v-if="!isAdmin" tooltip-position="top" :label="$t('plus_admin_log_in_text')">
            <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-6 tw:w-6" />
          </UiTooltip>
          <GhostButton @click="redirectToContact">{{ $t('plus_product_page_contact_cta') }}</GhostButton>
        </div>
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

import CheckMark from '@/components/icons/CheckMark.svg?component'
import MainButton from '@/components/base/buttons/MainButton.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'
import ContainerLayout from '@/layouts/ContainerLayout.vue'

import appAnalytics from '@/utils/tracking'
import { getContactUrl } from '@/utils/Utility.ts'
import { selectedAccommodationId } from '@/layouts/queries'
import { useCampaign } from '@/components/rateConnect/queries'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const store = useStore()
const props = defineProps({
  isAdmin: Boolean,
})

const emit = defineEmits(['upgradeSub'])
const upgradeSub = () => {
  if (props.isAdmin) {
    appAnalytics.track(appAnalytics.events.SP_CLICK_UPGRADE_PAIN_POINTS, {
      accommodationId: selectedAccommodationId.value,
    })
    emit('upgradeSub')
  } else {
    appAnalytics.track(appAnalytics.events.SP_LOGIN_AS_ADMIN_CLICKED, {
      accommodationId: selectedAccommodationId.value,
    })
    store.dispatch('session/logout', '/studio-plus/compare?loginAsAdmin=true')
  }
}

const { userId, language } = useSessionValues()
const { campaignsData } = useCampaign(selectedAccommodationId)
const { studioPlusCampaign } = useStudioPlusCampaign(selectedAccommodationId)
const isPaidClient = computed(
  () =>
    Boolean(studioPlusCampaign.value) ||
    (Array.isArray(campaignsData.value) ? campaignsData.value.length > 0 : Boolean(campaignsData.value))
)
const supportCenterUrl = computed(() =>
  getContactUrl(language.value, userId.value, selectedAccommodationId.value, isPaidClient.value)
)
const redirectToContact = () => {
  return window.open(supportCenterUrl.value, '_blank')
}
const list = [
  'plus_product_page_benefit_1',
  'plus_product_page_benefit_2',
  'plus_product_page_benefit_3',
  'plus_product_page_benefit_4',
]
</script>
